import { IconType } from '@aibees/shared/components';
import React from 'react';

export interface WhiteLabelLeftSideProps {
  className?: string;
}

export enum FieldType {
  TEXT,
  FILE,
}

export interface WhiteLabelField {
  placeholder?: string;
  startIcon?: IconType;
  endIcon?: IconType;
  error?: boolean;
  fieldType: FieldType;
  errorMessage?: string;
  label?: string;
  color?: string;
  onChange?: (value: string) => void;
  onChangeFile?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  file?: File;
}
